<mat-expansion-panel
  *ngIf="!showErrorsOnly || (showErrorsOnly && error)"
  (opened)="panelOpenState = true"
  (closed)="panelOpenState = false"
  [ngClass]="{ 'error-accordion': error }"
  class="log-entry"
>
  <mat-expansion-panel-header *ngIf="!data.message" fxLayout="row">
    <mat-panel-title *ngIf="!data.message" matTooltip="Alias: {{ renderAlias }}">
      <span>{{ renderClassName }}</span>
    </mat-panel-title>

    <mat-panel-description
      fxLayout="row"
      fxLayoutAlign="end center"
      fxLayoutGap="6px"
      *ngIf="data.action !== 'teacherReview'"
    >
      <div [ngClass]="{ error: error, success: !error }">
        <mat-icon>{{ statusIcon }}</mat-icon>
      </div>
      <span>{{ renderTeacher }}</span>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <mat-expansion-panel-header *ngIf="data.message">
    <div>
      {{ data.message }}
    </div>
  </mat-expansion-panel-header>

  <div fxLayout="column">
    <div *ngIf="!data.message" fxLayout="column" fxLayoutGap="6px">
      <div *ngIf="data.summaryMessage" [ngClass]="{ error: error }" fxLayoutAlign="start center" fxLayoutGap="6px">
        <mat-icon>{{ statusIcon }}</mat-icon>
        <span>{{ data.summaryMessage }}</span>
        <span *ngIf="data.errorCode">({{ _parseErrorCode(data) }})</span>
      </div>

      <div *ngIf="data.id" [ngClass]="{ error: error }" fxLayoutAlign="start center" fxLayoutGap="6px">
        <span><strong>Classroom ID: </strong></span>
        <span>{{ data.id }}</span>
      </div>

      <div *ngIf="data.rosterChanges?.add.length" fxLayout="column">
        <span
          ><strong data-test="sync-history-dialog__single-log-entry__roster-error-title">Roster additions</strong></span
        >
        <span *ngFor="let student of data.rosterChanges?.add">
          {{ student.userId }} ({{ _parseErrorCode(student) }})
        </span>
      </div>

      <div *ngIf="data.rosterChanges?.remove.length" fxLayout="column">
        <span
          ><strong data-test="sync-history-dialog__single-log-entry__roster-error-title">Roster removals</strong></span
        >
        <span *ngFor="let student of data.rosterChanges?.remove">
          {{ student.userId }} ({{ _parseErrorCode(student) }})
        </span>
      </div>

      <div *ngIf="data.metaDataUpdates?.length" fxLayout="column">
        <span
          ><strong data-test="sync-history-dialog__single-log-entry__roster-error-title">Metadata changes</strong></span
        >
        <span *ngFor="let update of data.metaDataUpdates">
          <strong>{{ update.field }}</strong> change to <em>{{ update.value }}</em> ({{ _parseErrorCode(update) }})
        </span>
      </div>

      <div *ngIf="data.teacherReviewChanges?.failed?.length" fxLayout="column" fxLayoutGap="6px">
        <p>The following teacher email addresses were not found:</p>
        <div
          *ngFor="let teacher of data.teacherReviewChanges.failed"
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="18px"
        >
          <mat-icon>warning</mat-icon>
          <span fxFlex>{{ teacher }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="data.errors" fxLayout="column" fxLayoutGap="6px">
      <div *ngFor="let badEmail of data.errors" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="18px">
        <mat-icon>warning</mat-icon>
        <span fxFlex>{{ badEmail.email }}</span>
        <span>({{ badEmail.classes.length }} enrollment{{ badEmail.classes.length === 1 ? '' : 's' }})</span>
      </div>
    </div>

    <div *ngIf="debug" class="debug">{{ data | json }}</div>
  </div>
</mat-expansion-panel>
